import { Component, OnInit, ChangeDetectionStrategy, signal, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QueryService } from 'src/app/core/services/query.service';
import { IElaborazione } from '../models/elaborazione.model';
import { ElaborazioniService } from '../elaborazioni.service';
import { ELABORAZIONI_COLUMNS,ELABORAZIONI_VISIBLECOLUMNS, ELABORAZIONI_ENDPOINT_QUERY_SERVICE_INSTANCE } from '../elaborazioni.config';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PageListComponent } from 'src/app/layout/pages/page-list/page-list.component';
import { FiltersFormComponent } from '../filters-form/filters-form.component';

@Component({
  selector: 'app-lista-page',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PageListComponent,
    FiltersFormComponent
  ],
  templateUrl: './lista-page.component.html',
  styleUrl: './lista-page.component.css'
})
export class ListaPageComponent implements OnInit {
  columns = ELABORAZIONI_COLUMNS;
  visibleColumns = signal(ELABORAZIONI_VISIBLECOLUMNS);
  insertForm: FormGroup;
  filterForm: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    @Inject(ELABORAZIONI_ENDPOINT_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<IElaborazione>,
    public elaborazioneService: ElaborazioniService
  ) {
    this.insertForm = this.fb.group<IElaborazione>(<IElaborazione>{});
    this.filterForm = this.fb.group({
      search: this.fb.control('', []),
      filters: this.fb.group({})
    });
  }

  ngOnInit(): void {
    this.elaborazioneService.getAll()
    .subscribe((data) => {
      console.log(data);
    })
  }

  get filters(): FormGroup {
    return this.filterForm.get('filters') as FormGroup;
  }
}